import FullScreenDialog from "designSystem/components/dialog/FullScreenDialog";
import ZoomInMapIcon from "designSystem/components/icon/ZoomInMapIcon";
import { Button, IconButton, MessageDialog } from "designSystem/index";
import Header from "csi/page/Header";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { goBackToPreviousNode } from "../ProofService";
import ManageProofPopup from "./ManageProofPopup";
import { useManageProofStore } from "./ManageProofStore";

const ViewProof: FunctionComponent = observer((props) => {
	const {
		endProofAction,
		hasProofBeenUpdatedByAnotherUser,
		isManageProofPopupOpen,
		openManageProofPopup,
		proofDocumentName,
		proofUrl,
		showManageProofButton,
	} = useManageProofStore();

	const headerLeftChildren = (
		showManageProofButton && (
			<Button 
				design="secondary"
				onClick={openManageProofPopup}
				res="ManageProof"
				size="large"
			/>
		) 
	);

	const headerRightChildren = (
		<IconButton
			design="iconOnlyOnColor"
			onClick={goBackToPreviousNode}
			size="large"
			sx={{
				marginRight: 3,
			}}
		>
			<ZoomInMapIcon />
		</IconButton>
	);

	return (
		<FullScreenDialog open>
			<Header
				leftChildren={headerLeftChildren}
				rightChildren={headerRightChildren}
				title={proofDocumentName}
			/>
			<ManageProofPopup open={isManageProofPopupOpen} />
			<MessageDialog
				buttonRes="Refresh"
				category="warn"
				messageRes="NewUpdatesOnProofMessage"
				onClose={endProofAction}
				open={hasProofBeenUpdatedByAnotherUser}
				titleRes="NewUpdatesOnProofTitle"
			/>
			<iframe
				allowFullScreen
				frameBorder="0"
				id="ziflow-proof-viewer"
				src={proofUrl}
				style={{ flex: 1 }}
			/>
		</FullScreenDialog>
	);
});

export default ViewProof;